import {UIMHomepageController} from './homepage/UIMHomepageController'
import {UIMLeaderboardController} from './leaderboard/UIMLeaderboardController'
import {UIMLobbyController} from './lobby/UIMLobbyController'
import {UIMProfileController} from './profile/UIMProfileController'
import {UIMStoreController} from './store/UIMStoreController'
import {UIMSceneController} from '../../UIMSceneController'
import {UIMNavigationController} from '../navigation/UIMNavigationController'
import {UIMMainPageController} from '../UIMMainPageController'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import Splide from '@splidejs/splide'
import {UIProfileRankedController} from '../../../../../shared/scripts/profile/UIProfileRankedController'

export class UIMBodyController {
    private readonly bodyContainer: HTMLDivElement

    readonly homepageController: UIMHomepageController
    readonly leaderboardController: UIMLeaderboardController
    readonly lobbyController: UIMLobbyController
    readonly storeController: UIMStoreController

    private profileController: UIMProfileController

    readonly swipeNavigation: Splide
    readonly sceneController: UIMSceneController
    readonly navigationController: UIMNavigationController

    constructor(sceneController: UIMSceneController, mainpageController: UIMMainPageController) {
        this.bodyContainer = document.getElementById('main-page-body-container') as HTMLDivElement

        this.homepageController = new UIMHomepageController()
        this.leaderboardController = new UIMLeaderboardController()
        this.lobbyController = new UIMLobbyController()
        this.storeController = new UIMStoreController()
        this.sceneController = sceneController

        this.navigationController = mainpageController.navigationController
        const parentContainer = document.getElementById('main-page-body-container')
        const parentContainerHeight = parentContainer?.clientHeight ?? window.innerHeight
        const padding = 20
        this.swipeNavigation = new Splide('.splide', {
            type: 'slide',
            perPage: 1,
            start: 2,
            arrows: false,
            pagination: false,
            flickMaxPages: 1,
            flickPower: 100,
            height: parentContainerHeight - padding,
            perMove: 1,
            noDrag: 'input, textarea, .m-no-drag',
        }).mount()

        const track = document.getElementById('splide01-track')
        if(track) {
            track.addEventListener('touchstart', (e: TouchEvent) => {
                if(e.touches.length > 1) this.swipeNavigation.refresh()
            })
        }

        this.swipeNavigation.on('move', (e: number) => {
            this.slideChange(e)
        })

        window.addEventListener('resize', () => {
            const newParentContainerHeight = parentContainer?.clientHeight ?? window.innerHeight
            this.swipeNavigation.options.height = newParentContainerHeight - padding
        })

        ClientUserState.registerChangeListener(() => {
            this.init()
        })
    }

    init() {
        if(this.profileController !== undefined) return
        if(ClientUserState.userState == undefined) return
        const username = ClientUserState.userState.username
        this.profileController = new UIMProfileController(username)
        new UIProfileRankedController(username)
    }

    private slideChange(scene: number) {
        this.sceneController.onSceneChange(scene)
        this.navigationController.moveSliderTo(scene)
    }

    hide() {
        this.bodyContainer.style.display = 'none'
        this.homepageController.onHomepageHide()
    }

    show() {
        this.bodyContainer.style.display = 'block'
    }
}
